import { Button } from '@/components/ui/Button/Button';
import { paths } from '@/config/paths';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { ChevronRight, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { APP_HEADER_HEIGHT_IN_PX } from '../AppHeader/AppHeader';
import { SYSTEM_BANNER_HEIGHT, withSystemBannerOffset } from '../SystemBanner/utils/systemBannerHeight';
import { useLocation } from 'react-router';

export const ALERT_BANNER_DESKTOP_HEIGHT_IN_PX = 60;
export const ALERT_BANNER_MOBILE_HEIGHT_IN_PX = 100;

interface AlertBannerProps {
  alert: 'creditCardExpiriesSoon' | 'paymentFailed' | 'invoiceOverdue' | null;
  style?: React.CSSProperties;
}

export const AlertBanner = ({ alert, style }: AlertBannerProps) => {
  const { t } = useTranslation('components', { keyPrefix: 'alertBanner' });
  const location = useLocation();

  const isDesktop = useMediaQuery('desktop');

  if (!alert) return null;

  const getMobileTopValue = () => {
    const isNotificationsSubpage = location.pathname === paths.notifications.home.path;

    return withSystemBannerOffset(isNotificationsSubpage ? APP_HEADER_HEIGHT_IN_PX + 38 : APP_HEADER_HEIGHT_IN_PX);
  };

  return (
    <div
      className='bg-fill-accent desktop:fixed desktop:z-10 desktop:items-center desktop:justify-center desktop:px-4 desktop:py-0 absolute top-0 left-0 flex w-full gap-4 px-5 py-5'
      style={{
        height: isDesktop ? `${ALERT_BANNER_DESKTOP_HEIGHT_IN_PX}px` : `${ALERT_BANNER_MOBILE_HEIGHT_IN_PX}px`,
        top: isDesktop ? SYSTEM_BANNER_HEIGHT : getMobileTopValue(),
        ...style,
      }}
      role='alert'
      aria-live='polite'
      data-testid='alert-banner'
    >
      <TriangleAlert className='text-text-brand-primary desktop:-mr-1 size-6' />
      <div className='desktop:flex-row desktop:items-center desktop:gap-4 flex flex-col'>
        <p>{t(`${alert}.title`)}</p>
        <Button variant='link' asChild className='text-text-brand-primary flex items-center justify-start gap-2 px-0 whitespace-normal'>
          <Link to={paths.managementPanel.billing.home.path}>
            {t(`${alert}.button.label`)}
            <ChevronRight className='size-5' />
          </Link>
        </Button>
      </div>
    </div>
  );
};
